import { DeliveryMode } from '../../../../../services/exports/Constants';

export default {
  header: 'Nieuwe bestellingen pauzeren',
  sections: {
    pause_orders: {
      title: 'Hoe lang bent u niet beschikbaar?',
      description: 'We informeren klanten dat u momenteel geen nieuwe bestellingen accepteert',
    },
    order_methods: {
      title: 'Mijn bestelmethoden',
      description: 'Schakel methoden in of uit waarmee klanten bij u kunnen bestellen',
    },
    delivery_mode: {
      title: 'Bezorgmethoden',
      description: 'Wissel tussen uw en ons bezorgnetwerk',
    },
  },
  form: {
    orders_paused_until: {
      options: {
        '10_min': '10 min',
        '15_min': '15 min',
        '20_min': '20 min',
        '25_min': '25 min',
        '1_hour': '1 uur',
        '2_hours': '2 uur',
        rest_of_day: 'Rest van de dag',
      },
    },
    has_standalone_delivery: {
      label: 'Mijn bezorgers',
    },
    has_external_delivery: {
      label: '{{provider}} bezorgnetwerk',
    },
  },
  labels: {
    delivery_orders_off: 'Bezorgorders uit',
    delivery_orders_on: 'Bezorgorders aan',
  },
  modals: {
    toggle_delivery: {
      [true]: {
        title: 'Weet u zeker dat u bezorgorders wilt inschakelen?',
        description: '',
      },
      [false]: {
        title: 'Weet u zeker dat u bezorgorders wilt uitschakelen?',
        description: '',
      },
    },
    switch_delivery_mode: {
      [DeliveryMode.Internal]: {
        title: 'Weet u zeker dat u wilt overschakelen naar uw bezorgers?',
        description: '',
      },
      [DeliveryMode.External]: {
        title: 'Weet u zeker dat u wilt overschakelen naar {{provider}}-bezorgers?',
        description: '',
      },
    },
  },
  buttons: {
    confirm: 'Bevestigen',
    cancel: 'Annuleren',
  },
  toasts: {
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen succesvol opgeslagen',
  },
};
